import type { AxiosError } from 'axios';
import { createMutation } from 'react-query-kit';

import { client } from '@/api/common';

type Variables = {
  reservationId: number;
};

// Emails the customer their sign-and-pay link for a pending reservation.
export const useSendSignLink = createMutation<void, Variables, AxiosError>({
  mutationFn: async ({ reservationId }) => {
    await client.post(
      `v2/internal/partners/reservations/${reservationId}/send-sign-link`
    );
  },
});
